import React, { useEffect, useMemo, useState } from 'react';
import { Button } from '@material-ui/core';
import IfComponent from '../../shared/IfComponent';
import CreateNewPageFromExistingPage from '../CreateNewPageFromExistingPage';
import { CREATE_NEW_PAGE_USING, DEFAULT_COUNTRY_LANGAUGE } from '../../../constants/content-recommendations';
import { useSelector } from 'react-redux';
import { getCountryDetailsByAlpfa3 } from '../../../constants/CountryAndLanguages';
import DiscoverKeywords from '../../shared/DiscoverKeywords';
import { useSchema } from '../../../utility/services/customHooks';
import { COMPONENT_NAMES, SCREEN_NAMES, trackAnalyticsEvent } from '../../../constants/analyticsMeta';

const CreateContentBrief = () => {
  const [showForm, setShowForm] = useState(false);
  const [showCreateNewPagePopUp, setShowCreateNewPagePopUp] = React.useState(false);
  const [defaultCountryLanguage, setDefaultCountryLanguage] = useState<typeof DEFAULT_COUNTRY_LANGAUGE | undefined>(
    undefined
  );
  const [directKeywords, setDirectKeywords] = React.useState<string[] | undefined>(undefined);
  const schemaName = useSchema();
  const customerInfo = useSelector((state) => state.root.customerInfo);
  const [primaryCountry, setPrimaryCountry] = useState({
    ...DEFAULT_COUNTRY_LANGAUGE,
  }); // CUSTOMER COUNTRY

  useEffect(() => {
    if (customerInfo && customerInfo?.length) {
      const customerData = customerInfo.find((customer) => customer?.cust_code === schemaName);
      const countryDetails = getCountryDetailsByAlpfa3(customerData?.primary_country);
      const defaultCountryAndLanguage = {
        ...DEFAULT_COUNTRY_LANGAUGE,
      };
      if (countryDetails) {
        defaultCountryAndLanguage.country = {
          ...defaultCountryAndLanguage.country,
          ...countryDetails,
        };
        defaultCountryAndLanguage.language = {
          ...defaultCountryAndLanguage.language,
          location_code: countryDetails?.location_code,
        };
      }
      setPrimaryCountry({
        ...defaultCountryAndLanguage,
      });
    }
  }, [schemaName, customerInfo]);

  const getCountryAndLanguage = useMemo(() => {
    const pageLavelDetails = { ...DEFAULT_COUNTRY_LANGAUGE };
    if (primaryCountry?.country) {
      pageLavelDetails.country = primaryCountry?.country;
    }
    return {
      country: {
        ...pageLavelDetails.country,
      },
      language: {
        ...pageLavelDetails.language,
        location_code: pageLavelDetails.country.location_code,
      },
    };
  }, [primaryCountry]);

  return (
    <>
      <span>
        {/* <DiscoverKeywords
          style={{ marginRight: '8px' }}
          className={`primary-button font-500-ft12-lh16 text-white text-title-case radius-0`}
          onKeywordsSelect={(list, defaultCountryLanguage) => {
            trackAnalyticsEvent({
              eventFor: 'button',
              buttonText: 'form open',
              payload: {
                label: 'Create New Page with discovery keywords',
                component_name: COMPONENT_NAMES.content_recommendations,
                screen_name: SCREEN_NAMES.content_recommendations,
              },
            });
            setDirectKeywords(list);
            setShowCreateNewPagePopUp(true);
            setDefaultCountryLanguage(defaultCountryLanguage);
          }}
          includeActionLabel="Create New Page"
        /> */}
        <Button
          className="primary-button font-500-ft12-lh16 text-white text-title-case radius-0"
          data-testid="add-new-link-button"
          onClick={() => {
            trackAnalyticsEvent({
              eventFor: '',
              buttonText: '',
              eventName: 'Create New Page Form Open',
              payload: {
                label: 'Create New Page Form Open',
                component_name: COMPONENT_NAMES.content_recommendations,
                screen_name: SCREEN_NAMES.content_recommendations,
              },
            });
            setShowForm(true);
          }}
          // endIcon={<AddIcon />}
        >
          Create New Page
        </Button>
      </span>
      <IfComponent isValid={showForm}>
        <CreateNewPageFromExistingPage
          creatingPageFrom={CREATE_NEW_PAGE_USING?.FROM_NEW}
          setShowCreateNewPagePopUp={setShowForm}
          language_country_details={defaultCountryLanguage || getCountryAndLanguage}
          redirectToNewTab={true}
        />
      </IfComponent>
      {showCreateNewPagePopUp ? (
        <CreateNewPageFromExistingPage
          creatingPageFrom={CREATE_NEW_PAGE_USING?.FROM_KEYWORD_GAP}
          setShowCreateNewPagePopUp={setShowCreateNewPagePopUp}
          language_country_details={defaultCountryLanguage || getCountryAndLanguage}
          discoveredKeywords={directKeywords}
          redirectToNewTab={true}
        />
      ) : null}
    </>
  );
};

export default React.memo(CreateContentBrief);
